var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "886 488 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M914.75 488h-24.167c-.69 0-1.25.56-1.25 1.25v.417h-2.083c-.69 0-1.25.56-1.25 1.25v14.166a2.917 2.917 0 0 0 2.917 2.917H913.5a2.5 2.5 0 0 0 2.5-2.5v-16.25c0-.69-.56-1.25-1.25-1.25Zm-25.833 17.5a.417.417 0 0 1-.417-.417v-12.916h.833v12.916c0 .23-.186.417-.416.417Zm12.291-.833h-7.916a.625.625 0 0 1-.625-.625v-.417c0-.345.28-.625.625-.625h7.916c.345 0 .625.28.625.625v.417c0 .345-.28.625-.625.625Zm10.834 0h-7.917a.625.625 0 0 1-.625-.625v-.417c0-.345.28-.625.625-.625h7.917c.345 0 .625.28.625.625v.417c0 .345-.28.625-.625.625Zm-10.834-5h-7.916a.625.625 0 0 1-.625-.625v-.417c0-.345.28-.625.625-.625h7.916c.345 0 .625.28.625.625v.417c0 .345-.28.625-.625.625Zm10.834 0h-7.917a.625.625 0 0 1-.625-.625v-.417c0-.345.28-.625.625-.625h7.917c.345 0 .625.28.625.625v.417c0 .345-.28.625-.625.625Zm0-5h-18.75a.625.625 0 0 1-.625-.625v-2.084c0-.345.28-.625.625-.625h18.75c.345 0 .625.28.625.625v2.084c0 .345-.28.625-.625.625Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Icon awesome-newspaper"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionsIcon);
export default __webpack_public_path__ + "static/media/SubscriptionsIcon.595107c4dd422d5953fde5f523bc12dd.svg";
export { ForwardRef as ReactComponent };